import { useEffect, useState } from 'react';

import UserService from '@/services/user.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import FormError from '@/shared-components/error/components/FormError';
import InputCode from '@/shared-components/inputs/components/InputCode';
import Text from '@/shared-components/text/components/Text';

import './styles/ClaimArtworkForm.css';

export default function ClaimArtworkForm({ onArtworkFound }) {
  const [formState, setFormState] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const elementName = 'claim_code';
  const firstElement = `${elementName}-0`;

  // we use newClaimCode value because the async that the setFormstateHAs
  async function submitClaimArtwork(newClaimCode) {
    // length 6 is to verify that the claimcode is correct
    if(newClaimCode.length === 6) {
      setError(null);
      setLoading(true);

      const claimCode = newClaimCode.join("");
  
      const { response, data } = await UserService.claimArtwork(claimCode);
  
      if(response.ok) {
        onArtworkFound(data);
      } else if(response.status === 404) {
        setError({ element: firstElement, error_code: "INVALID_CLAIM_CODE" });
        setLoading(false);
      }
    }
  }

  // This is to hide the error if exists on formState change
  useEffect(() => {
    setError(null);
  },[formState]);

  const claimEnabled = formState.every((value) => !!value) && formState.length === 6;

  return (
    <>
      <form onSubmit={e=>{e.preventDefault(); submitClaimArtwork(formState);}} className="claim-artwork-form">
        <Text className="claim-artwork-form__text" paragraph justify small>
                    Did you recently buy an artwork that's featured on Suarte from a physical Gallery? 
                    Please enter the unique verification code that was sent to your email after your purchase.
        </Text>

        <InputCode
          readOnly={loading}
          value={formState}
          codeType="alphanumeric"
          className="claim-artwork-form__input-code"
          onChange={value=>setFormState(value)}
          onComplete={submitClaimArtwork}
          elementName={elementName}
        />
        { error && 
          <FormError 
            error={error} 
            alternativeElement={firstElement} 
            element={firstElement}
          />
        }

        <Text className="claim-artwork-form__text" paragraph justify small>
                    If you can't find the code reach out to us at {" "}
          <a href = "mailto: contact@suarte.art">contact@suarte.art</a>.
        </Text>

        <ContinueButton className="claim-artwork-form__button font-size-medium" loading={loading} turnOff={!claimEnabled}>
                    Claim artwork
        </ContinueButton>
      </form>
    </>
  );
}
